import { UI_BODY_SM_DF } from 'oolib';
import React from 'react';

/**
 * Renders one FIXED text in every cell of its column, ignoring row data
 * entirely. For transient column states — e.g. "Updating data…" while a
 * field-type-change migration is converting the column's values.
 */
const TableStaticText = ({ text, color }) => {
    if (!text) return null;

    return (
        <UI_BODY_SM_DF style={{ ...(color ? { color } : {}), fontStyle: 'italic' }}>
            {text}
        </UI_BODY_SM_DF>
    );
};

export default TableStaticText;
